import React from 'react';
import HeroSlider from '../components/HeroSlider';
import GemstoneGrid from '../components/GemstoneGrid';
import GemstoneList from '../components/GemstoneList';
import ShopImage from '../components/ShopSection/ShopImage';
import { homePageIntro } from '../data/gemstoneData';

const Home = () => {
  return (
    <>
      <HeroSlider />
      <GemstoneGrid />
      <div style={{ padding: '40px 20px', maxWidth: '1200px', margin: '0 auto', textAlign: 'center' }}>
        <h2 style={{ fontSize: '36px', marginBottom: '20px', color: '#333' }}>{homePageIntro.title}</h2>
        <p style={{ fontSize: '18px', lineHeight: '1.8', color: '#666', maxWidth: '800px', margin: '0 auto' }}>{homePageIntro.description}</p>
      </div>
      <GemstoneList />
      <ShopImage />
    </>
  );
};

export default Home;
